import { ArrowForwardIos, CastForEducation, ManageAccounts, Newspaper, People } from "@mui/icons-material";
import { Box, Card, CardActionArea, CardContent, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { SystemObjectStore } from "../../ObjectStore/SystemObjectStore";
import { UserObjectStore } from "../../ObjectStore/UserObjectStore";
import StoreList from "../organisms/StoreList";

const HomePage: React.FC = () => {
    const navigate = useNavigate()
    const { userObjectState } = React.useContext(UserObjectStore)
    const { systemObject } = React.useContext(SystemObjectStore)

    return (
        <Box>
            <Grid
                container
                spacing={2}
                alignItems="stretch"
            >
                {(userObjectState.stfAccessList.includes("CustomerAdmin") && systemObject.databaseVersion && systemObject.databaseVersion >= 11 && systemObject.enableOnlineLesson) &&
                    <Grid item xs={12} sm={6} md={4}>
                        <Card
                            sx={{
                                height: "100%"
                            }}
                        >
                            <CardActionArea
                                onClick={() => {
                                    navigate("/online_lesson")
                                }}
                                sx={{
                                    height: "100%"
                                }}
                            >
                                <CardContent>
                                    <Stack
                                        direction={"row"}
                                        spacing={2}
                                        alignItems={"center"}
                                        sx={{
                                            height: "100%"
                                        }}
                                    >
                                        <CastForEducation />
                                        <Typography variant="h2" sx={{ flexGrow: 1 }}>オンラインレッスン</Typography>
                                        <ArrowForwardIos />
                                    </Stack>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                }
                {userObjectState.stfAccessList.includes("CustomerAdmin") &&
                    <Grid item xs={12} sm={6} md={4}>
                        <Card
                            sx={{
                                height: "100%"
                            }}
                        >
                            <CardActionArea
                                onClick={() => {
                                    navigate("/customer")
                                }}
                                sx={{
                                    height: "100%"
                                }}
                            >
                                <CardContent>
                                    <Stack
                                        direction={"row"}
                                        spacing={2}
                                        alignItems={"center"}
                                        sx={{
                                            height: "100%"
                                        }}
                                    >
                                        <People />
                                        <Typography variant="h2" sx={{ flexGrow: 1 }}>顧客管理</Typography>
                                        <ArrowForwardIos />
                                    </Stack>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                }
                {userObjectState.stfAccessList.includes("StaffAdmin") &&
                    <Grid item xs={12} sm={6} md={4}>
                        <Card
                            sx={{
                                height: "100%"
                            }}
                        >
                            <CardActionArea
                                onClick={() => {
                                    navigate("/staff")
                                }}
                                sx={{
                                    height: "100%"
                                }}
                            >
                                <CardContent>
                                    <Stack
                                        direction={"row"}
                                        spacing={2}
                                        alignItems={"center"}
                                        sx={{
                                            height: "100%"
                                        }}
                                    >
                                        <ManageAccounts />
                                        <Typography variant="h2" sx={{ flexGrow: 1 }}>スタッフ管理</Typography>
                                        <ArrowForwardIos />
                                    </Stack>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                }
                {userObjectState.stfAccessList.includes("NewsAdmin") &&
                    <Grid item xs={12} sm={6} md={4}>
                        <Card
                            sx={{
                                height: "100%"
                            }}
                        >
                            <CardActionArea
                                onClick={() => {
                                    navigate("/news")
                                }}
                                sx={{
                                    height: "100%"
                                }}
                            >
                                <CardContent>
                                    <Stack
                                        direction={"row"}
                                        spacing={2}
                                        alignItems={"center"}
                                        sx={{
                                            height: "100%"
                                        }}
                                    >
                                        <Newspaper />
                                        <Typography variant="h2" sx={{ flexGrow: 1 }}>ニュース管理</Typography>
                                        <ArrowForwardIos />
                                    </Stack>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                }
                {userObjectState.stfAccessList.includes("StoreSetting") &&
                    <Grid item xs={12}>
                        <StoreList />
                    </Grid>
                }
            </Grid>
        </Box>
    )
}

export default HomePage